<template>
  <div id="app">
    <LoginModal />
    <div class="appWrapper">
      <div class="appContentWrapper">
        <ProgressBar progress="progressValue" mode="indeterminate" v-if="loading" />
        <TopMenu v-if="show" />
        <div class="viewWrapper">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main'
import SideMenu from '@/components/Menus/SideMenu'
import TopMenu from '@/components/Menus/TopMenu'
import LoginModal from '@/components/Modals/LoginModal'
import ProgressBar from 'primevue/progressbar'
export default {
  name: 'App',
  components: {
    SideMenu,
    TopMenu,
    LoginModal,
    ProgressBar
  },
  data () {
    return {
      show: false,
      loading: false,
      role: '',
      timer: '',
      progressValue: 0
    }
  },
  methods: {
    isLoggedIn: function () {
      if (localStorage.getItem('token') !== null) {
        const token = localStorage.getItem('token') || ''
        const decodedToken = this.$jwtDec.decode(token)
        this.show = (Date.now() / 1000) < decodedToken.exp
      } else {
        this.show = false
      }
    }
  },
  created: function () {
    bus.$on('loggedIn', show => {
      this.show = show
    })
    bus.$on('role', role => {
      this.role = role
    })
    bus.$on('loading', loading => {
      this.loading = loading
    })
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout')
            .then(() => {
              bus.$emit('loggedIn', false)
              this.$router.push('/')
            })
        }
        throw err
      })
    })
    this.isLoggedIn()
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue